import Popin from './Popin'
export default Popin



// WEBPACK FOOTER //
// ./node_modules/gvue/src/core/Popin/index.js